import IAppLogger from '@app/lib/IAppLogger';
import { audioDevicesState } from '@modules/SoftPhoneModule/audioDevicesState';
import { webPhoneEventNames } from '@modules/SoftPhoneModule/constants/events';

/**
 * Handles `webphone:mic-monitor-stopped` from the webphone MFE when microphone
 * monitoring stops (explicit stop, device removed, or disconnect).
 */
const handleMicMonitorStopped = (logger: IAppLogger): void => {
  logger.debug(webPhoneEventNames.micMonitorStopped, {});
  audioDevicesState.isTestingMicrophone = false;
};

export default handleMicMonitorStopped;
